import React from "react";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

interface TextFilterProps {
    label: string;
    value: string;
    setFilter: (value: string) => void;
    isMobile: boolean;
}

const DateFilter: React.FC<TextFilterProps> = ({label, value, setFilter, isMobile}) => (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">
        <DatePicker
            label={label}
            value={value ? dayjs(value) : null}
            slotProps={{textField: {variant: 'standard', fullWidth: isMobile}, field: {clearable: true}}}
            onChange={(e) => setFilter(e?.format('YYYY-MM-DD') ?? '')}
            sx={{minWidth: 180, mt: 1}}
        />
    </LocalizationProvider>
);

export default DateFilter;